<!-- Оздоровительно-диагностический центр / Ознакомление с Центром -->
<template>
    <div class="lang arabic">
        <div class="info">
            <div class="full-width"><img src="/resource/img/center-bg.jpg" alt="" class="full-width--bg">
                <h3 class="title01">Wellness Center</h3>
                <h4 class="title03">
                    العافية مفهوم يشمل كلا من "الرفاهية"
                    و"اللياقة البدنية"،وهو أساسي لحياة
                    عيدة مع الصحة البدنية والعقلية والاجتماعية في تناغم.
                    يقدم مركز العافية لتعزيز الصحة خدمات إدارة
                    حية موثوق بها كمرافق في حياتك الصحية والسعيدة.
                </h4>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">برنامج مخصص</h3>
            <p class="bullet03 depth">نحن نوفر برامج مخصصة بناءً على الميزات الفردية لكل عميل من خلال الاستشارة الفردية مع المنسق في زيارة شخصية أو من خلال خدمة "الاتصال السعيد" على الإنترنت أو الحجز عبر الهاتف.</p>
            <p class="bullet03 depth">لقد أنشأنا برنامجًا فريدًا يناسب الخصائص الفردية المختلفة، مع خيارات يسهل الاختيار منها.</p>
            <p class="bullet03 depth">لقد طبقنا نظاما ذكيا لإجراء مقابلات طبية على الإنترنت والرجوع إلى تاريخ العائلة الشخصي وعادات الحياة والأعراض غير المريحة حتى يمكن تطبيق البيانات في تحديد ضرورة إجراء فحوصات إضافية وتحليل نتيجة الفحص الطبي.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">إجراء فحوصات طبية دقيقة بمساعدة مرافق طبية حديثة وموظفين طبيين ذوي خبرة.</h3>
            <p class="bullet03 depth">لدينا فريق طبي ذو خبرة مخصص حصريا لمركز تعزيز الصحة، وطاقم طبي مكون من أساتذة متعاونون في الإدارات يمكن أن يكونوا على اتصال وثيق بهم على الفور. ولزيادة دقة التشخيصات لدينا،</p>
            <p class="bullet03 depth">نحن مجهزون بمجموعة واسعة من الأجهزة الطبية الحديثة المختلفة بما في ذلك الأشعة المقطعية (CT) والرنين المغناطيسي (MRI) والموجات فوق الصوتية والتصوير المقطعي بالبوزيترون (Pet) ومنظار الجسم.</p>
            <p class="bullet03 depth">عند تشخيص السرطان أو غيره من الأمراض الخطيرة، سيقوم طاقم العاملين والمنسقون الطبيون الذين تم تعيينهم فقط للعافية بربطك فورا وبشكل منتظم بعلاج العيادات الخارجية.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">توفير تجربة فحص طبي متميزة</h3>
            <p class="bullet03 depth">ستتمكن بفضل اتساع مساحة العيادة الخاصة بنا ومساحة الانتظار المريحة من خوض تجربة فحص طبي مبهجة.</p>
            <p class="bullet03 depth">إن أماكن الانتظار وأماكن الإقامة لكبار الشخصيات اختيارية لمن يرغبون في الترقية إلى الفحص الطبي المتميز</p>
        </div>
    </div>
</template>
<script>

    export default {
    }

</script>